module.exports = __webpack_public_path__ + "static/media/callout-illustration.b0d8f85c.png";